<template>
    <v-dialog v-model="show" no-click-animation persistent width="900">
        <div class="ScenarioRephrasePrompt">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc("rephrasePrompt") }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <!--Content dialog-->
            <div
                class="dialog-content"
                ref="contentDialog"
                style="padding: 0 !important; margin: 0;"
            >
                <div class="display-flex" style="height: 100%">
                    <div class="input-box fci-scrollbar">
                        <!--Prompt-->
                        <div class="label">{{ $f.tc("prompt") }}</div>
                        <v-textarea
                            id="prompt"
                            v-model="prompt"
                            class="textarea-custom"
                            spellcheck="false"
                            :rows="7"
                            :placeholder="$f.tc('enterPrompt')"
                        ></v-textarea>

                        <!--List buttons-->
                        <div class="centerY justify-space-between mt-8">
                            <div
                                id="btn_config_model_llm"
                                class="btn-config-model"
                                :class="
                                    isOpenConfig ? 'btn-config-activated' : ''
                                "
                                @click="isOpenConfig = !isOpenConfig"
                            >
                                <div
                                    style="margin-right: 3px; padding-bottom: 4px"
                                >
                                    {{ modelActivated.icon }}
                                </div>
                                {{ modelActivated.mdl }}
                                <img
                                    v-if="!isOpenConfig"
                                    src="/img/scenario/config.svg"
                                    alt="icon-config-model"
                                />
                                <img
                                    v-else
                                    src="/img/scenario/config_blue.svg"
                                    alt="icon-config-model-activated"
                                />
                            </div>
                            <div class="ml-2 mr-2">
                                <v-select
                                    v-if="!isOpenConfig"
                                    class="select-custom"
                                    :items="styles"
                                    v-model="styleSelect">

                                </v-select>
                            </div>
                            <div
                                v-if="!isLoading"
                                id="btn_rephrase_prompt"
                                class="btn-custom btn-rephrase mr-0"
                                @click="rephrasePrompt"
                            >
                                <img
                                    src="/img/scenario/rewrite_white.svg"
                                    alt="icon-rephrase"
                                />
                                {{ $f.tc("rephrase") }}
                            </div>
                            <div
                                v-else
                                class="btn-custom btn-rephrase btn-rephrasing mr-0"
                            >
                                <v-progress-circular
                                    indeterminate
                                    color="#fff"
                                    style="width: 16px; margin-right: 6px"
                                ></v-progress-circular>
                                {{ $f.tc("rephrase") }}
                            </div>
                        </div>

                        <!--Config model-->
                        <div class="config-box" v-if="isOpenConfig">
                            <!--Model-->
                            <div class="centerY justify-space-between p-12" style="border-bottom: 1px solid #d9d9d9">
                                <div class="centerY">
                                    <label class="label" for="model">{{
                                            $f.tc("model")
                                        }}</label>
                                    <v-tooltip top class="mr-6" :nudge-top="-6">
                                        <template v-slot:activator="{ on }">
                                            <img
                                                src="/img/scenario/help-circle.svg"
                                                alt="icon-more-info-model"
                                                v-on="on"
                                            />
                                        </template>
                                        <div style="max-width: 250px">
                                            {{ $f.tc("modelDescription") }}
                                        </div>
                                    </v-tooltip>
                                </div>
                                <div style="width: 200px">
                                    <v-select
                                        id="model"
                                        class="select-custom"
                                        :items="models"
                                        v-model="config.model"
                                        item-text="name"
                                        item-value="id"
                                        disabled
                                    ></v-select>
                                </div>
                            </div>

                            <div class="p-12">
                                <!--System prompt-->
                                <div class="mb-12">
                                    <div class="centerY mb-1">
                                        <label class="label" for="systemPrompt">{{
                                                $f.tc("systemPrompt")
                                            }}</label>
                                        <v-tooltip top class="mr-6" :nudge-top="-6">
                                            <template v-slot:activator="{ on }">
                                                <img
                                                    src="/img/scenario/help-circle.svg"
                                                    alt="icon-more-info-model"
                                                    v-on="on"
                                                />
                                            </template>
                                            <div style="max-width: 250px">
                                                {{ $f.tc("systemPromptInfo") }}
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <v-textarea
                                        id="prompt"
                                        v-model="config.sysPrompt"
                                        class="textarea-custom"
                                        spellcheck="false"
                                        :rows="5"
                                        :placeholder="$f.tc('enterPrompt')"
                                    ></v-textarea>
                                </div>

                                <!--Temperature-->
                                <div class="centerY mt-8 justify-space-between">
                                    <div class="centerY">
                                        <label class="label" for="model"
                                        >Temperature</label
                                        >
                                        <v-tooltip top class="mr-6" :nudge-top="-6">
                                            <template v-slot:activator="{ on }">
                                                <img
                                                    src="/img/scenario/help-circle.svg"
                                                    alt="icon-more-info-temperature"
                                                    v-on="on"
                                                />
                                            </template>
                                            <div style="max-width: 250px">
                                                {{
                                                    $f.tc("temperatureDescription")
                                                }}
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <div style="width: 80px">
                                        <v-text-field
                                            v-model="config.temperature"
                                            hide-details
                                            type="number"
                                            min="0"
                                            max="1"
                                            step="0.1"
                                            class="input-custom"
                                        ></v-text-field>
                                    </div>
                                </div>

                                <!--Top P-->
                                <div class="centerY mt-8 justify-space-between">
                                    <div class="centerY">
                                        <label class="label" for="model"
                                        >Top P</label
                                        >
                                        <v-tooltip top class="mr-6" :nudge-top="-6">
                                            <template v-slot:activator="{ on }">
                                                <img
                                                    src="/img/scenario/help-circle.svg"
                                                    alt="icon-more-info-topP"
                                                    v-on="on"
                                                />
                                            </template>
                                            <div style="max-width: 250px">
                                                {{ $f.tc("topPDescription") }}
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <div style="width: 80px">
                                        <v-text-field
                                            v-model="config.topP"
                                            hide-details
                                            type="number"
                                            min="0"
                                            max="1"
                                            step="0.1"
                                            class="input-custom"
                                        ></v-text-field>
                                    </div>
                                </div>

                                <!--Max tokens-->
                                <div class="centerY mt-8 justify-space-between">
                                    <div class="centerY">
                                        <label class="label" for="model"
                                        >Max Tokens</label
                                        >
                                        <v-tooltip top class="mr-6" :nudge-top="-6">
                                            <template v-slot:activator="{ on }">
                                                <img
                                                    src="/img/scenario/help-circle.svg"
                                                    alt="icon-more-info-topP"
                                                    v-on="on"
                                                />
                                            </template>
                                            <div style="max-width: 250px">
                                                {{ $f.tc("maxTokensDescription") }}
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <div style="width: 80px">
                                        <v-text-field
                                            v-model="config.maxTokens"
                                            hide-details
                                            type="number"
                                            min="0"
                                            max="4096"
                                            step="1"
                                            class="input-custom"
                                        ></v-text-field>
                                    </div>
                                </div>

                                <!--N-->
                                <div class="centerY mt-8 justify-space-between">
                                    <div class="centerY">
                                        <label class="label" for="model">N</label>
                                        <v-tooltip top class="mr-6" :nudge-top="-6">
                                            <template v-slot:activator="{ on }">
                                                <img
                                                    src="/img/scenario/help-circle.svg"
                                                    alt="icon-more-info-topP"
                                                    v-on="on"
                                                />
                                            </template>
                                            <div style="max-width: 250px">
                                                {{ $f.tc("nDescription") }}
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <div style="width: 80px">
                                        <v-text-field
                                            v-model="config.n"
                                            hide-details
                                            type="number"
                                            min="0"
                                            max="10"
                                            step="1"
                                            class="input-custom"
                                        ></v-text-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Output-->
                    <div class="output-box fci-scrollbar"
                         :style="{paddingBottom: showApply ? '0 !important' : '12px !important'}"
                    >
                        <!--Loading-->
                        <div
                            v-if="isLoading"
                            class="centerXY"
                            style="height: 100%; flex-direction: column; color: #727885"
                        >
                            <v-progress-circular
                                indeterminate
                                color="#0052CC"
                                style="width: 24px; margin-bottom: 3px"
                            ></v-progress-circular>
                            {{ $f.tc("rephrasing") }}
                        </div>

                        <!--Error-->
                        <div
                            v-else-if="isHasError"
                            class="centerXY"
                            style="height: 100%; flex-direction: column; color: #727885;"
                        >
                            <img
                                src="/img/scenario/error-page.png"
                                alt="icon-error-page"
                                style="width: 80px"
                                class="mb-2"
                            />
                            <div style="text-align: center; width: 85%">
                                {{ $f.tc("rephraseError") }}
                            </div>
                        </div>

                        <template v-else>
                            <!--Nothing-->
                            <div
                                v-if="promptsOutput.length === 0"
                                class="centerXY"
                                style="height: 100%; flex-direction: column; color: #727885;"
                            >
                                <img
                                    src="/img/scenario/stars-prompt.png"
                                    alt="icon-stars-prompt"
                                    style="width: 80px"
                                    class="mb-2"
                                />
                                <div style="text-align: center; width: 85%">
                                    {{ $f.tc("rephraseIntro") }}
                                </div>
                            </div>

                            <!--Prompts output-->
                            <template v-else>
                                <div class="label">
                                    {{ $f.tc("rephrasedPromptIntro") }}
                                </div>
                                <div
                                    v-for="(item, idx) in promptsOutput"
                                    :key="`prompt_${idx}`"
                                    class="prompt-output"
                                >
                                    {{ item.text }}
                                    <div
                                        class="display-flex justify-space-between align-end mt-6"
                                    >
                                        <div class="length-prompt">
                                            {{ item.text.length }}
                                            {{ $f.tc("chars") }}
                                        </div>
                                        <v-checkbox
                                            v-model="item.apply"
                                            style="padding: 0 !important;display: flex;align-items: center;justify-content: right; height: 15px"
                                        >
                                        </v-checkbox>
                                    </div>
                                </div>
                                <div v-if="showApply" class="dialog-footer footer-custom">
                                    <div class="btn-custom mr-0"
                                         @click="applyPrompt">{{ $f.tc('createNewPrompts') }}
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";
import ScenarioService from "@/services/scenario.service";

const models = [
    {
        id: "SaoLa3-Engage-Rewrite",
        name: "SaoLa3-Engage-Rewrite",
        icon: "🐐",
        mdl: "SaoLa"
    }
];

const styles = [
    "lịch sự",
    "chuyên nghiệp",
    "trang trọng",
    "thân thiện",
    "khích lệ",
    "thúc giục",
    "kiên quyết",
    "đồng cảm"
]

export default {
    name: "ScenarioRephrasePrompt",
    mixins: [DialogPromiseMixin],
    data() {
        return {
            models,
            styles,
            styleSelect: "lịch sự",
            prompt: "",
            config: {
                model: "SaoLa3-Engage-Rewrite",
                sysPrompt: "Dùng tiếng Việt để diễn đạt lại câu input sao cho thật lịch sự, tự nhiên mà vẫn giữ nguyên ý nghĩa gốc.",
                topP: 0.9,
                maxTokens: 100,
                temperature: 0.7,
                n: 5
            },
            isOpenConfig: false,
            isLoading: false,
            isHasError: false,
            promptsOutput: [],
            showApply: false,
        };
    },
    computed: {
        isEdit() {
            return (
                ScenarioService.isEditable() && ScenarioService.isModeEditing()
            );
        },
        modelActivated() {
            const model = models.find(i => i.id === this.config.model);
            return model || models[0];
        }
    },
    methods: {
        open(promptInput) {
            this.isOpenConfig = false;
            this.styleSelect = "lịch sự"
            this.prompt = promptInput;
            this.config.sysPrompt = "Dùng tiếng Việt để diễn đạt lại câu input sao cho thật " + this.styleSelect + ", tự nhiên mà vẫn giữ nguyên ý nghĩa gốc.";
            this.promptsOutput = []

            this.show = true;
            this.rephrasePrompt()
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject};
            });
        },
        rephrasePrompt() {
            const scenarioId = this.$route.params.scenarioId
            if (!scenarioId || !this.prompt) {
                return
            }

            if (!this.isOpenConfig) {
                this.config.sysPrompt = "Dùng tiếng Việt để diễn đạt lại câu input sao cho thật " + this.styleSelect + ", tự nhiên mà vẫn giữ nguyên ý nghĩa gốc.";
            }

            const data = {
                prompt: this.prompt,
                ...this.config
            }
            this.isLoading = true
            ScenarioService.rephrasePrompt(scenarioId, data).then(result => {
                this.isHasError = false
                const choices = result.data.choices
                this.promptsOutput = choices.map(i => ({text: i.text, apply: false}))
            }).catch(() => this.isHasError = true).finally(() => this.isLoading = false)
        },
        applyPrompt() {
            let selectedPrompts = this.promptsOutput.filter(obj => obj['apply']).map(obj => obj.text).map(prompt => prompt.trim())
            this.$emit("applyPrompt", selectedPrompts);
            this.close()
        },
    },
    watch: {
        promptsOutput: {
            deep: true,
            handler: function (newPromptsOutput) {
                this.showApply = newPromptsOutput.some(obj => obj['apply'])
            }
        }
    }
};
</script>

<style scoped lang="scss">
.ScenarioRephrasePrompt {
    background: #ffffff;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        margin: 12px 0 0 12px;
        padding: 0 12px 12px 0 !important;
        position: relative;
    }

    .btn-custom {
        margin-right: 8px;
    }

    .label {
        font-size: 14px;
        font-family: "open sans semi", serif;
        margin-bottom: 4px;
    }
}

.input-box,
.output-box {
    flex: 1;
    padding: 12px;
    height: 68.2vh;
    overflow-y: auto;
    overflow-x: hidden;
}

.input-box {
    border-right: 1px solid #f0f0f0;

    .btn-config-model {
        display: flex;
        align-items: center;
        padding: 0 10px;
        height: 32px;
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        font-family: "open sans semi", serif;
        color: #727885;
        cursor: pointer;
        user-select: none;

        img {
            width: 18px;
            margin-left: 8px;
        }
    }

    .config-box {
        margin-top: 12px;
        border: 1px solid #d9d9d9;
        border-radius: 5px;

        img {
            width: 16px;
            margin-left: 2px;
            padding-top: 1px;
        }

        .label {
            margin-bottom: 0 !important;
            font-size: 14px;
        }
    }

    .btn-config-activated {
        color: #0052cc;
        border-color: #eef6ff !important;
        background: #eef6ff;
    }

    .btn-rephrase {
        background: linear-gradient(
                99deg,
                hsla(0, 0%, 100%, 0.12) 7.16%,
                hsla(0, 0%, 100%, 0) 85.47%
        ),
        linear-gradient(280deg, #fbc255 12.96%, #f7722f 90.95%);
        font-family: "open sans semi", serif;

        img {
            width: 15px;
            margin-right: 6px;
        }

        &:hover {
            background: linear-gradient(
                    99deg,
                    hsla(0, 0%, 100%, 0.12) 7.16%,
                    hsla(0, 0%, 100%, 0) 85.47%
            ),
            linear-gradient(280deg, #fbd86f 12.96%, #ff9869 90.95%);
        }
    }

    .btn-rephrasing {
        background: linear-gradient(
                99deg,
                hsla(0, 0%, 100%, 0.12) 7.16%,
                hsla(0, 0%, 100%, 0) 85.47%
        ),
        linear-gradient(280deg, #fbd86f 12.96%, #ff9869 90.95%);
        cursor: default !important;
    }
}

.output-box {
    .prompt-output {
        display: flex;
        flex-direction: column;
        gap: 8px;
        background: #f2f2f2cc;
        padding: 8px 10px;
        border-radius: 5px;
        margin-top: 8px;

        &:first-child {
            margin-top: 0;
        }
    }
}

.textarea-custom {
    ::v-deep {
        .v-input__slot {
            background: #f2f2f2cc;
            border-radius: 5px;
            outline: none;
            font-size: 14px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before,
            &:after {
                border: none !important;
            }
        }

        .v-messages {
            min-height: 0 !important;
        }
    }
}

.input-custom,
.select-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #ffffff;
            border-radius: 5px;
            border: 1px solid #d9d9d9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before,
            &:after {
                border: none !important;
            }
        }
    }
}

.select-custom {
    ::v-deep {
        .v-input__slot {
            padding: 6px 4px 6px 12px !important;
        }
    }
}

.length-prompt {
    font-family: "open sans", serif;
    font-size: 13px;
    color: #8f97a6;
}

::v-deep {
    textarea {
        padding: 8px 10px !important;
    }

    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field__details {
        display: none;
    }
}

.footer-custom {
    position: sticky !important;
    bottom: 1px;
    z-index: 1;
    background: #FFFFFF;
    padding: 12px !important;
}
</style>
